import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";
import { LOGO_URL, CONTACT_EMAIL, CONTACT_PHONE, CONTACT_PHONE_TEL, SIGNUP_URL } from "../lib/site";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-[#0B192C] text-slate-300" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-3" data-testid="footer-brand">
              <img src={LOGO_URL} alt="CashPark Inc" className="h-10 w-10 object-contain" />
              <span className="font-display font-bold text-xl text-white">
                CashPark <span className="text-[#FF6B00]">Inc</span>
              </span>
            </Link>
            <p className="mt-4 text-sm leading-relaxed text-slate-400">
              The best Naira–CAD currency exchange platform. Built for the Nigerian-Canadian community.
            </p>
          </div>

          <div>
            <h4 className="font-display font-semibold text-white mb-4">Company</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/about" className="hover:text-[#FF6B00]" data-testid="footer-link-about">About</Link></li>
              <li><Link to="/blogs" className="hover:text-[#FF6B00]" data-testid="footer-link-blogs">Blogs</Link></li>
              <li><Link to="/faq" className="hover:text-[#FF6B00]" data-testid="footer-link-faq">FAQ</Link></li>
              <li><Link to="/contact" className="hover:text-[#FF6B00]" data-testid="footer-link-contact">Contact Us</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-display font-semibold text-white mb-4">Legal</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/privacy" className="hover:text-[#FF6B00]" data-testid="footer-link-privacy">Privacy Policy</Link></li>
              <li><Link to="/aml-kyc" className="hover:text-[#FF6B00]" data-testid="footer-link-aml">AML / KYC Policy</Link></li>
              <li><Link to="/terms" className="hover:text-[#FF6B00]" data-testid="footer-link-terms">Terms & Conditions</Link></li>
              <li>
                <a href={SIGNUP_URL} target="_blank" rel="noopener noreferrer" className="hover:text-[#FF6B00]" data-testid="footer-link-signup">
                  Sign Up / Verify
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-display font-semibold text-white mb-4">Get in touch</h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-2">
                <Phone size={16} className="mt-0.5 text-[#FF6B00]" />
                <a href={`tel:${CONTACT_PHONE_TEL}`} className="hover:text-white" data-testid="footer-phone">{CONTACT_PHONE}</a>
              </li>
              <li className="flex items-start gap-2">
                <Mail size={16} className="mt-0.5 text-[#FF6B00]" />
                <a href={`mailto:${CONTACT_EMAIL}`} className="hover:text-white break-all" data-testid="footer-email">{CONTACT_EMAIL}</a>
              </li>
              <li className="flex items-start gap-2">
                <MapPin size={16} className="mt-0.5 text-[#FF6B00]" />
                <span>Calgary, Alberta, Canada</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-slate-800 text-xs text-slate-400 leading-relaxed space-y-3" data-testid="footer-regulatory">
          <p>
            CashPark Inc is registered and regularised by the Financial Transactions and Report Analysis Centre of Canada (FINTRAC) as a Money Service Business. MSB registration number: C100000408.
          </p>
          <p>
            CashPark Inc. is also registered as a Payment Service Provider (PSP) and regulated by the Bank of Canada under the Retail Payment Activities Act (RPAA) for the payment services it provides.
          </p>
        </div>

        <div className="mt-8 pt-8 border-t border-slate-800 text-xs text-slate-500 flex flex-col sm:flex-row gap-3 justify-between">
          <p>© {year} CashPark Inc. All rights reserved.</p>
          <p>Licensed money services business. Rates shown are illustrative; final rate confirmed at transfer.</p>
        </div>
      </div>
    </footer>
  );
}
